// angular
import {NgModule} from "@angular/core";
import {RouterModule} from '@angular/router';
import {CommonModule} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {BrowserModule} from '@angular/platform-browser';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {InfiniteScrollModule} from "ngx-infinite-scroll";
// bootstrap
import {BsDropdownModule} from 'ngx-bootstrap/dropdown';
import {CollapseModule} from 'ngx-bootstrap/collapse';
// maglive
import {CommentListComponent} from "./comment-list/comment-list.component";
import {HeaderComponent} from './header/header.component';
import {SpinnerComponent} from './spinner/spinner.component';
import {PlayerComponent} from './player/player.component';
import {ViewErrorDialogComponent} from "./dialog/view-error-dialog.component";
import {PlayerOverlayDialogComponent} from "./dialog/player-overlay-dialog.component";
import {LiveCardComponent} from "./live-card/live-card.component";
import {IndexHeaderComponent} from './index-header/index-header.component';
import {FollowDialogComponent} from './dialog/follow-dialog.component';
import {AdminHeaderComponent} from "./admin/header/admin-header.component";
import {AdminFooterComponent} from "./admin/footer/admin-footer.component";
import {AdminSidebarComponent} from "./admin/sidebar/admin-sidebar.component";
import {AdminLiveIndexComponent} from "./admin/live/index/live-index.component";
import {AdminLiveIndexDetailComponent} from "./admin/live/index-detail/live-index-detail.component";
import { NgWordComponent } from './admin/ng-word/ng-word.component';
import { FollowerCountComponent } from './admin/follower-count/follower-count.component';
import { MaintenanceShowComponent } from './admin/maintenance/maintenance-show/maintenance-show.component';
import { MaintenanceCreateComponent } from './admin/maintenance/maintenance-create/maintenance-create.component';
import { ConfigShowComponent } from './admin/config/config-show/config-show.component';
import { ConfigCreateComponent } from './admin/config/config-create/config-create.component';
import { CreatorIndexComponent } from './admin/creator/creator-index/creator-index.component';
import {DashboardIndexComponent} from './admin/dashboard/index/dashboard-index.component';
import {ProfileRemoveComponent} from './admin/profile-remove/profile-remove.component';
import {SuspendUserComponent} from './admin/suspend-user/suspend-user.component';
import {SuspendMagazineComponent} from './admin/suspend-magazine/suspend-magazine.component';
import {CommentDeleteComponent} from './admin/comment-delete/comment-delete.component';
import { LiveCreateComponent } from "./admin/live/create/live-create.component";
import { LiveEditComponent } from "./admin/live/edit/live-edit.component";
import { AdminPointPlanIndexComponent } from "./admin/point-plan/index/point-plan-index.component";
import { AdminGiftIndexComponent } from "./admin/gift/index/gift-index.component";
import { AdminGiftCreateComponent } from "./admin/gift/create/gift-create.component";
import { AdminGiftEditComponent } from "./admin/gift/edit/gift-edit.component";
import { AdminPointPlanCreateComponent } from "./admin/point-plan/create/point-plan-create.component";
import { AdminPointPlanEditComponent } from "./admin/point-plan/edit/point-plan-edit.component";
import { AdminPointBalanceIndexComponent } from "./admin/point-balance/index/point-balance-index.component";
import { AdminSalesHistoryIndexComponent } from "./admin/sales-history/index/sales-history-index.component";
import { AdminPointHistoryIndexComponent } from "./admin/point-history/index/point-history-index.component";
import { AdminOrderHistoryIndexComponent } from "./admin/order-history/index/order-history-index.component";
import { InputCommentComponent } from "./comment-input/input-comment.component";
import { GiftCommentComponent } from "./gift/gift-comment/gift-comment.component";
import { GiftQuestionComponent } from "./gift/gift-question/gift-question.component";
import { GiftChargeComponent } from "./gift/gift-charge/gift-charge.component";
import { GiftChargeForPageComponent } from "./gift/gift-charge-for-page/gift-charge-for-page.component";
import { PointManageComponent } from "./gift/point-manage/point-manage.component";
import { PointHistoryAllComponent } from "./gift/point-history-all/point-history-all.component";
import { PointHistoryDetailComponent } from "./gift/point-history-detail/point-history-detail.component";
import { MagazineIndexComponent } from "./revenue/magazine-index/magazine-index.component";
import { RevenueIndexComponent } from "./revenue/revenue-index/revenue-index.component";
import { RevenueDetailComponent } from "./revenue/revenue-detail/revenue-detail.component";
import { TransferIndexComponent } from './admin/transfer/transfer-index/transfer-index.component';
import { MaintenanceComponent } from "./maintenance/maintenance.component";
import { UpdateNicknameComponent } from "./gift/update-nickname/update-nickname.component";
import { NoticeModalComponent } from './gift/notice-modal/notice-modal.component'
import { LoginAlertComponent } from "./alert/login-alert/login-alert.component"
import { CreatorCommentComponent } from './creator-comment/creator-comment.component'
import { PlayerHeaderComponent } from './player/player-header/player-header.component'
import { VariantModalComponent } from './player/variant-modal/variant-modal.component'
import { ShareModalComponent } from './player/share-modal/share-modal.component'
import { GiftAnimationComponent } from './player/gift-animation/gift-animation.component'
// - for animation
import { LottieModule } from 'ngx-lottie';
import player from 'lottie-web';
import { ArchiveCreateComponent } from "./admin/archive/create/archive-create.component";
import { ArchiveEditComponent } from "./admin/archive/edit/archive-edit.component";
// - pipes
import {
   ConvertPointFluckKindToTextPipe, 
   ConvertOrderStatusToTextPipe, 
   ConvertThousandNumPipe,
   ConvertFirestoreTimestampToString,
   ConvertFileSizeToString,
} from "../../lib/pipe";

export const playerFactory = () => {
  return player;
}
@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    CollapseModule.forRoot(),
    BsDropdownModule.forRoot(),
    FormsModule,
    ReactiveFormsModule,
    BrowserModule,
    BrowserAnimationsModule,
    InfiniteScrollModule,
    LottieModule.forRoot({ player: playerFactory }),
  ],
  exports: [
    CommentListComponent,
    HeaderComponent,
    LiveCardComponent,
    SpinnerComponent,
    PlayerComponent,
    ViewErrorDialogComponent,
    PlayerOverlayDialogComponent,
    IndexHeaderComponent,
    FollowDialogComponent,
    CommentDeleteComponent,
    SuspendUserComponent,
    ProfileRemoveComponent,
    DashboardIndexComponent,
    AdminHeaderComponent,
    AdminFooterComponent,
    AdminSidebarComponent,
    AdminLiveIndexComponent,
    AdminLiveIndexDetailComponent,
    NgWordComponent,
    FollowerCountComponent,
    MaintenanceShowComponent,
    MaintenanceShowComponent,
    MaintenanceCreateComponent,
    ConfigShowComponent,
    CreatorIndexComponent,
    SuspendMagazineComponent,
    LiveCreateComponent,
    ArchiveCreateComponent,
    LiveEditComponent,
    AdminPointPlanIndexComponent,
    AdminPointPlanCreateComponent,
    AdminPointPlanEditComponent,
    AdminGiftIndexComponent,
    AdminGiftCreateComponent,
    AdminGiftEditComponent,
    AdminPointBalanceIndexComponent,
    AdminSalesHistoryIndexComponent,
    AdminPointHistoryIndexComponent,
    AdminOrderHistoryIndexComponent,
    InputCommentComponent,
    GiftCommentComponent,
    GiftQuestionComponent,
    GiftChargeComponent,
    GiftChargeForPageComponent,
    PointManageComponent,
    PointHistoryAllComponent,
    PointHistoryDetailComponent,
    MagazineIndexComponent,
    RevenueIndexComponent,
    RevenueDetailComponent,
    TransferIndexComponent,
    MaintenanceComponent,
    UpdateNicknameComponent,
    NoticeModalComponent,
    LoginAlertComponent,
    CreatorCommentComponent,
    PlayerHeaderComponent,
    VariantModalComponent,
    ShareModalComponent,
    GiftAnimationComponent,
    ArchiveCreateComponent,
    ArchiveEditComponent,
  ],
  declarations: [
    CommentListComponent,
    HeaderComponent,
    LiveCardComponent,
    SpinnerComponent,
    PlayerComponent,
    ViewErrorDialogComponent,
    PlayerOverlayDialogComponent,
    IndexHeaderComponent,
    FollowDialogComponent,
    CommentDeleteComponent,
    ProfileRemoveComponent,
    AdminHeaderComponent,
    AdminFooterComponent,
    AdminSidebarComponent,
    AdminLiveIndexComponent,
    AdminLiveIndexDetailComponent,
    NgWordComponent,
    FollowerCountComponent,
    MaintenanceShowComponent,
    MaintenanceCreateComponent,
    ConfigShowComponent,
    ConfigCreateComponent,
    CreatorIndexComponent,
    DashboardIndexComponent,
    SuspendUserComponent,
    SuspendMagazineComponent,
    LiveCreateComponent,
    ArchiveCreateComponent,
    ArchiveEditComponent,
    LiveEditComponent,
    AdminPointPlanIndexComponent,
    AdminPointPlanCreateComponent,
    AdminPointPlanEditComponent,
    AdminGiftIndexComponent,
    AdminGiftCreateComponent,
    AdminGiftEditComponent,
    AdminPointBalanceIndexComponent,
    AdminSalesHistoryIndexComponent,
    AdminPointHistoryIndexComponent,
    AdminOrderHistoryIndexComponent,
    InputCommentComponent,
    GiftCommentComponent,
    GiftQuestionComponent,
    GiftChargeComponent,
    GiftChargeForPageComponent,
    PointManageComponent,
    PointHistoryAllComponent,
    PointHistoryDetailComponent,
    MagazineIndexComponent,
    RevenueIndexComponent,
    RevenueDetailComponent,
    TransferIndexComponent,
    MaintenanceComponent,
    UpdateNicknameComponent,
    NoticeModalComponent,
    LoginAlertComponent,
    CreatorCommentComponent,
    PlayerHeaderComponent,
    VariantModalComponent,
    ShareModalComponent,
    GiftAnimationComponent,
    // pipes
    ConvertFileSizeToString,
    ConvertPointFluckKindToTextPipe,
    ConvertOrderStatusToTextPipe,
    ConvertThousandNumPipe,
    ConvertFirestoreTimestampToString,
  ],
})
export class PartsModule {}
